// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f6c12881","454":"ee4fbe52","596":"a203f088","669":"100a9f07","677":"e0c07ec2","679":"b1eb9485"}[chunkId] + ".chunk.js";
};